import { Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";

import { useState } from "react";
import ClinicalSiteInfo from "./ClinicalSiteInfo";
import ContractInfo from "./ContractInfo";
import SponsorInfo from "./SponsorInfo";
import StudyInfo from "./StudyInfo";

import "../index.css";

export default function Info(props) {
  const { sales } = props;

  const [studyInfoPopupVisible, setStudyInfoPopupVisible] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);

  const onStudyInfoEditButton = (e) => {
    setStudyInfoPopupVisible(true);
  };

  return (
    // <div className="container">
    <div className={`container${fullScreen ? `-full-screen` : ``}`}>
      <div className={`box${fullScreen ? `-full-screen` : ``}`}>
        <Toolbar>
          <Item location={"before"}>
            <span
              style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
            >
              CONTRACT INFO.
            </span>
          </Item>
          {/* <Item
            location={"after"}
            locateInMenu={"auto"}
            widget={"dxButton"}
            options={{
              icon: "edit",
              onClick: onContractInfoEditButton,
            }}
          /> */}
        </Toolbar>
        <ContractInfo sales={sales} />
      </div>
      <div className={`box${fullScreen ? `-full-screen` : ``}`}>
        <Toolbar>
          <Item location={"before"}>
            <span
              style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
            >
              STUDY INFO.
            </span>
          </Item>
          <Item
            location={"after"}
            locateInMenu={"auto"}
            widget={"dxButton"}
            options={{
              icon: "edit",
              onClick: onStudyInfoEditButton,
            }}
          />
        </Toolbar>
        <StudyInfo
          sales={sales}
          studyInfoPopupVisible={studyInfoPopupVisible}
          setStudyInfoPopupVisible={setStudyInfoPopupVisible}
        />
      </div>
      <div className="box">
        <Toolbar>
          <Item location={"before"}>
            <span
              style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
            >
              CLINICAL SITE INFO.
            </span>
          </Item>
        </Toolbar>
        <ClinicalSiteInfo
          sales={sales}
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
        />
      </div>
      <div className={`box${fullScreen ? `-full-screen` : ``}`}>
        <Toolbar>
          <Item location={"before"}>
            <span
              style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
            >
              SPONSOR INFO.: {sales.sprName}
            </span>
          </Item>
        </Toolbar>
        <SponsorInfo sales={sales} />
      </div>
    </div>
  );
}
